import styles from "./analytics-cards.module.css"

export default function LiveOrdersCard({ orders }) {
  return (
    <div className={styles.card}>
      <h3>Live Orders</h3>
      <div className={styles.orderStats}>
        <div className={styles.stat}>
          <span className={styles.count}>{orders?.pending}</span>
          <span className={styles.label}>Pending</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.count}>{orders?.processing}</span>
          <span className={styles.label}>Processing</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.count}>{orders?.failed}</span>
          <span className={styles.label}>Failed</span>
        </div>
      </div>
    </div>
  )
}
